export default function init() {
  /*global ds07o6pcmkorn*/
  const frameName = new ds07o6pcmkorn({
    openElementId: "#shielded-logo",
    modalID: "modal",
  })

  frameName.init()

  const body = document.querySelector("body")
  const content = document.querySelector(".content-container")
  const btnShielded = document.querySelector("#shielded-logo")
  const config = { attributes: true, childList: true, subtree: true }
  const readerDisableList = [
    document.querySelector(".header"),
    document.querySelector(".content-container"),
    document.querySelector(".footer"),
  ]

  document.querySelectorAll(".skip-link").forEach(element => {
    readerDisableList.push(element)
  })

  const action = disable => {
    btnShielded.style.display = disable ? "none" : "inline-block"
    readerDisableList.forEach(item => {
      item.setAttribute("aria-hidden", disable ? "true" : "false")
    })
  }

  const observer = new MutationObserver(mutationsList => {
    for (const mutation of mutationsList) {
      if (mutation.type === "attributes") {
        if (mutation.target && mutation.target.id == "modal") {
          if (mutation.target.style.display == "none") {
            observer.disconnect()
            content.classList.toggle("is-visible", false)
            action(false)
          }
        }
      }
    }
  })

  if (btnShielded) {
    btnShielded.addEventListener("click", e => {
      e.preventDefault()
      action(true)
      content.classList.toggle("is-visible", true)
      observer.observe(body, config)
    })
  }
}
